import { useScrollReveal, useScrollRevealGroup } from '../../../hooks/useScrollReveal';
import { Link } from 'react-router-dom';

const stats = [
  { number: '3X', label: 'More Leads on Average', icon: 'ri-user-add-line' },
  { number: '52', suffix: 'DAYS', label: 'To #1 Google Ranking', icon: 'ri-google-line' },
  { number: '98', suffix: '%', label: 'Client Retention Rate', icon: 'ri-heart-line' },
  { number: '126', suffix: '+', label: 'Local Businesses Transformed', icon: 'ri-building-2-line' },
];

export default function ResultsSection() {
  const titleRef = useScrollReveal(0);
  const groupRef = useScrollRevealGroup();

  return (
    <section id="results" className="relative pt-24 pb-16 bg-ds-bg overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-ds-blue/40 to-transparent" />
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-ds-blue/5 blur-[100px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div ref={titleRef} className="reveal text-center mb-20">
          <span className="section-label">Proof Of Domination</span>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-none">
            THE NUMBERS
            <br />
            <span className="text-ds-blue neon-text-blue">DON&apos;T LIE.</span>
          </h2>
        </div>

        {/* Stats */}
        <div
          className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-ds-border mb-6"
          ref={groupRef}
        >
          {stats.map((stat) => (
            <div key={stat.label} className="bg-ds-bg-2 p-5 lg:p-10 text-center reveal group">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 border border-ds-blue/20 group-hover:border-ds-blue/60 transition-colors duration-300">
                <i className={`${stat.icon} text-ds-blue text-xl`} />
              </div>
              <div className="font-display text-4xl sm:text-5xl md:text-6xl text-white mb-2">
                {stat.number}
                {stat.suffix && <span className="text-ds-red">{stat.suffix}</span>}
              </div>
              <p className="font-body text-white/50 text-xs tracking-wider uppercase leading-tight">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* AI Visibility Results Strip */}
        <div className="mb-16 reveal">
          <Link
            to="/geo-aeo"
            className="group block w-full border border-ds-red/30 bg-ds-bg-2 hover:border-ds-red/50 transition-all duration-300"
            style={{ borderTop: '2px solid #B4FF39', boxShadow: '0 0 40px rgba(180,255,57,0.07)' }}
          >
            <div className="px-8 py-7 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              {/* Label */}
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <span className="relative flex h-2 w-2 flex-shrink-0">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-ds-red opacity-60" />
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-ds-red" />
                  </span>
                  <span className="font-display text-ds-red text-xs tracking-[0.3em] uppercase">Now Tracking</span>
                </div>
                <p className="font-display text-white text-base leading-tight">
                  AI Search Visibility
                </p>
                <p className="font-body text-white/40 text-xs leading-relaxed max-w-sm">
                  As of 2026, we track AI citation metrics alongside traditional SEO for every client on a GEO programme.
                </p>
              </div>
              {/* Arrow CTA */}
              <div className="flex items-center gap-2 text-ds-red group-hover:gap-3 transition-all duration-300 flex-shrink-0">
                <span className="font-display text-xs tracking-widest uppercase whitespace-nowrap">Explore GEO / AEO</span>
                <div className="w-5 h-5 flex items-center justify-center border border-ds-red/40 group-hover:border-ds-red group-hover:bg-ds-red/10 transition-all duration-300">
                  <i className="ri-arrow-right-line text-xs" />
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Primary CTA */}
        <div className="mt-12 text-center reveal">
          <a
            href="#contact"
            className="btn-red inline-flex items-center gap-2 whitespace-nowrap"
          >
            <span>Get Your Free AI Visibility Audit</span>
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}